export * from "./accounts.component";



// WEBPACK FOOTER //
// ./src/app/modules/userHome/accounts/index.ts